/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DisabledLocation from '@components/location-toast';
import Icon from '@components/icon-component';
import Tags from '@components/tags';

import useLocation from '@hooks/useLocation';

import style from './style.module.scss';
import useNetworkStatus from '@hooks/useNetworkStatus';

const FilterSortBar = ({
  isHidden,
  loadingOnSearch,
  isFilterActive,
  filtersCount,
  tagsData,
  selectedFilter,
  setSelectedFilterEvent,
  setFilterActiveEvent,
  setLoadingEvent,
  detailPage,
  showEnableLocationNotificationOnMapBookmark
}) => {
  const [showLocationDisabledInfo, setShowLocationDisabledInfo] = useState(false);
  const [isOnline] = useNetworkStatus();

  const locationPermissionIsOn = useLocation();
  const { showMapView = false } = useSelector((state) => state.siteMap) || {};

  useEffect(() => {
    if (showEnableLocationNotificationOnMapBookmark) {
      locationHandlerEvent();
    }
  }, [showEnableLocationNotificationOnMapBookmark]);

  const locationHandlerEvent = () => {
    if (!isOnline) {
      setShowLocationDisabledInfo(true);
      setTimeout(() => {
        setShowLocationDisabledInfo(false);
      }, 5000);
    } else {
      if (!locationPermissionIsOn) {
        setShowLocationDisabledInfo(true);
        setTimeout(() => {
          setShowLocationDisabledInfo(false);
        }, 5000);
      } else {
        setLoadingEvent({ value: !showMapView });
      }
    }
  };

  return (
    <div
      className={`${showMapView && style.fixedSortBarOnTopOnMapView} ${
        showMapView && !isFilterActive && style.sortBarWidthWhenFilterIsInActive
      } `}
    >
      <DisabledLocation
        showLocationDisabledInfo={showLocationDisabledInfo}
        text={
          !isOnline
            ? 'An internet connection is needed for map view.'
            : 'Enable location permission for Oplii Mobile in your device or browser settings to see listings in map view.'
        }
      />

      <div
        className={`op-filter-sort ${style['op-filter-sort']} ${
          isHidden && !showMapView ? style.hidden : ''
        } ${style.filterSortBarPadding} `}
        style={{
          borderBottom: loadingOnSearch ? 'none ' : '1px solid rgb(229, 229, 229)'
        }}
      >
        <div
          className={style['op-filter-sort-content']}
          style={{ position: isHidden && !showMapView ? 'absolute' : 'static' }}
        >
          {!isFilterActive && (
            <div className={style.onlyIcon} onClick={() => setFilterActiveEvent(true)}>
              <div className={style.iconClass}>
                <Icon name={filtersCount > 0 ? 'filter-blue' : 'filter-black'} />
                {filtersCount > 0 && <span>{filtersCount}</span>}
              </div>
            </div>
          )}

          <div
            style={{ flex: 1 }}
            className={`btn-sort-wrap ${isFilterActive ? '' : 'btn-sort-wrap-list'}`}
          >
            {!isFilterActive && <div className="sort-by">Sort By</div>}
            <Tags tags={tagsData} value={selectedFilter} onChange={setSelectedFilterEvent} />
          </div>

          {!detailPage && (
            <button className={style.mapIcon} onClick={locationHandlerEvent}>
              <Icon
                name={
                  locationPermissionIsOn
                    ? showMapView
                      ? 'site-view-toggle-list'
                      : 'site-view-toggle'
                    : 'site-view-toggle-disabled'
                }
              />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterSortBar;
